import {
  useAttendeeStatus,
  useRosterState,
} from "amazon-chime-sdk-component-library-react";
import { VideoUIRosterItem } from "./VideoUIRosterItem";
import { extractRoomMemberData } from "@platform/features/video/utils/roomMemberDataUtils";
import { useVideo } from "@platform/features/video/providers/VideoContext";

export type Props = {
  /** The ID of a Chime meeting attendee. */
  attendeeId: string;
};

export function VideoUIRosterItemContainer({ attendeeId }: Props) {
  const { muted, videoEnabled, sharingContent } = useAttendeeStatus(attendeeId);
  const { roster } = useRosterState();
  const { roomMembersData } = useVideo();

  const attendee = roster[attendeeId];

  const { displayName, roomMemberData } = extractRoomMemberData(
    attendee,
    roomMembersData
  );

  return (
    <VideoUIRosterItem
      muted={muted}
      videoEnabled={videoEnabled}
      sharingContent={sharingContent}
      attendeeName={displayName}
      roomMemberData={roomMemberData}
    />
  );
}

export default VideoUIRosterItemContainer;
